if (!customElements.get('wlsn-video-tabs')) {
    class WLSNVideoTabs extends HTMLElement {
        constructor() {
            super();
            this.classes = {
                activeClass: 'is-active',
                visibleClass: 'is-visible',
                tab: 'js-wlsn-video-tabs-tab',
                content: 'js-wlsn-video-tabs-content'
            };

            this.elements = {
                tabs: this.querySelectorAll(`.${this.classes.tab}`),
                contents: this.querySelectorAll(`.${this.classes.content}`),
            }
        }

        connectedCallback() {
            this.initTabs();
        }

        initTabs() {
            const tabs = this.elements.tabs;
            const contents = this.elements.contents;
            const { activeClass, visibleClass } = this.classes;

            tabs.forEach((tab, index) => {
                tab.addEventListener('click', () => {
                   
                    tabs.forEach(t => t.classList.remove(activeClass));
                    tab.classList.add(activeClass);
                    
                    contents.forEach(c => c.classList.remove(visibleClass));
                    const contentEl = contents[index];
                    contentEl.classList.add(visibleClass);
                });
            });

            if (contents[0]) {
                contents[0].classList.add(visibleClass);
            }
        }

      
      
    }

    customElements.define('wlsn-video-tabs', WLSNVideoTabs);
}
